"use strict";
var ApolloProvider_1 = require("./ApolloProvider");
exports.ApolloProvider = ApolloProvider_1.default;
var graphql_1 = require("./graphql");
exports.graphql = graphql_1.default;
exports.withApollo = graphql_1.withApollo;
var redux_1 = require("redux");
exports.compose = redux_1.compose;
//# sourceMappingURL=browser.js.map


/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/react-apollo/lib/browser.js
 **/